export const SET_ENDPOINT_CONFIG = 'set_endpoint_config';
export const SET_GENERATION_CONFIG = 'set_generation_config';
export const SET_AUTH_KEY = 'set_auth_key';
export const SET_VDB_KEY = 'set_vdb_key';
export const CLEAR_AUTH_KEY = 'clear_auth_key';
export const USER_LOGOUT = 'logout';
export const USER_FETCH = 'user';
